import React, { useState } from 'react';
import { Sort } from 'esa-ui-library/lib/assets/icons/Sort';
import styles from '../GamesReportTable.module.scss';
import { find } from 'lodash';
import { allFieldsMap } from '../../GamesReport.const';
import { GRSort } from '../../types/games-report-interfaces';
import { GRColumsFormatKey } from '../../types/games-report-types';

interface TableHeadCellProps {
	data: GRColumsFormatKey;
	onSort: (sortParams: GRSort) => void;
}

const TableHeadCell: React.FC<TableHeadCellProps> = ({ data, onSort }): JSX.Element => {
	const [isAsc, setIsAcs] = useState<boolean>(true);

	const sortHandler = () => {
		const field = find(allFieldsMap, ['label', data])?.key as GRColumsFormatKey;
		onSort({ field, isAsc });
		setIsAcs((prevState) => !prevState);
	};

	return (
		<td className={`${styles.TableCell}`}>
			<div className={styles.TableHeadCell}>
				{data}
				<div className={styles.TableSort} onClick={sortHandler}>
					<Sort />
				</div>
			</div>
		</td>
	);
};

export default TableHeadCell;
